// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2H1q_","title":"Header_title__2Zg_F","side":"Header_side__3TrW4"};